import { Textarea, TextareaProps } from "@chakra-ui/react";
import { ChangeEvent, forwardRef, KeyboardEvent, MutableRefObject, useCallback, useEffect } from "react";

interface APTextareaProps extends TextareaProps {
  error?: string;
  id?: string;
}

const APTextarea = forwardRef<HTMLTextAreaElement, APTextareaProps>(
  ({ variant = "flushed", error, id, colorScheme = "tertiary", onChange, onKeyDown, ...others }, ref) => {
    const isInvalid = !!error;

    const onChangeCallback = useCallback((e: ChangeEvent<HTMLTextAreaElement>) => {
      e.target.style.minHeight = "auto";
      e.target.style.minHeight = `${e.target.scrollHeight}px`;
      onChange?.(e)
    }, [onChange])

    const onKeyDownCallback = useCallback((event: KeyboardEvent<HTMLTextAreaElement>) => {
      if (event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();
      }
      if (onKeyDown) {onKeyDown(event);}
    }, [onKeyDown])

    useEffect(() => {
      const elementRef = (ref as MutableRefObject<HTMLTextAreaElement>);
      if (elementRef) {
        elementRef.current.style.minHeight = "auto";
        elementRef.current.style.minHeight = `${elementRef.current.scrollHeight}px`;
      }
    }, [ref]);

    return (
      <>
        <Textarea resize={"none"} variant={variant} colorScheme={colorScheme} onKeyDown={onKeyDownCallback}
                  onChange={onChangeCallback}
                  id={id}
                  isInvalid={isInvalid} {...others} ref={ref} />
        {error != "" && <div className="error">{error}</div>}
      </>
    );
  }
);

export default APTextarea;
